import { CompositeFilterDescriptor, FilterDescriptor } from "@progress/kendo-data-query";

export function cleanFilters(compositeFilter: CompositeFilterDescriptor): CompositeFilterDescriptor {
    const cleanFilter = { ...compositeFilter };

    if (cleanFilter.filters && cleanFilter.filters.length) {
        cleanFilter.filters = cleanFilter.filters
            .map(filter => {
                // If it's a CompositeFilterDescriptor, clean recursively
                if ((filter as CompositeFilterDescriptor).filters) {
                    return cleanFilters(filter as CompositeFilterDescriptor);
                }

                const descriptor = filter as FilterDescriptor;

                // Check if the filter should be removed
                if (
                    descriptor.value === null &&
                    descriptor.operator !== 'isnull' &&
                    descriptor.operator !== 'isnotnull'
                ) {
                    return null;
                }

                return descriptor;
            })
            .filter(filter => filter !== null); // Remove null filters
    }

    return cleanFilter;
}

export function describeFilter(filter) {
    if (filter.filters) {
        // Composite filter: join each sub-filter with the logic operator
        return filter.filters.map(describeFilter).join(" " + filter.logic + " ");
    } else {
        // Single filter: format field, operator, and value into a string
        return filter.field + " " + filter.operator + " " + JSON.stringify(filter.value);
    }
}
